import { ArrowToBottomIcon } from "@t8891/icon";
import React, { memo } from "react";

function updateType(type, value) {
  // 将字符串拆分为数组
  let typeArray = typeof type === "string" ? type.split(",") : [];

  // 将值转换为字符串
  const strValue = String(value);

  // 检查值是否已经在数组中
  const index = typeArray.indexOf(strValue);

  if (index > -1) {
    // 如果值已经存在，则移除它
    typeArray.splice(index, 1);
  } else {
    // 如果值不存在，则添加它
    typeArray.push(strValue);
  }

  // 将数组重新转换为字符串
  return typeArray.join(",");
}

const AmountMenu: React.FC<any> = ({ params, onClick, total }) => {
  const { type, sort } = params;

  return (
    <div id='AmountMenu' className='w-930 text-20 text-black flex justify-between items-center my-6'>
      <div className='flex font-semibold'>
        共找到<div className='text-[#F87F15]'>{total}</div>條菜單
      </div>
      <div className='flex justify-between p-14 pr-0 gap-22'>
        <div className='flex gap-24'>
          <div
            className='flex gap-6 items-center text-15  cursor-pointer'
            onClick={() => {
              onClick({ type: updateType(type, "1") });
            }}
          >
            {type.includes("1") ? (
              <img className='w-14 h-14' src={"https://photo.8891.com.tw/2024/07/10/1720601987436520.png"} />
            ) : (
              <img className='w-14 h-14' src={"https://photo.8891.com.tw/2024/07/10/1720602048863686.png"} />
            )}
            菜單分享
          </div>
          <div
            className='flex gap-6 items-center text-15  cursor-pointer'
            onClick={() => {
              onClick({ type: updateType(type, "2") });
            }}
          >
            {type.includes("2") ? (
              <img className='w-14 h-14' src={"https://photo.8891.com.tw/2024/07/10/1720601987436520.png"} />
            ) : (
              <img className='w-14 h-14' src={"https://photo.8891.com.tw/2024/07/10/1720602048863686.png"} />
            )}
            徵求菜單
          </div>
        </div>
        <div className='flex items-center gap-6 text-14'>
          <div
            className={`${
              ["postDate-desc", "postDate-asc"].includes(sort) ? "text-[#3264FF]" : ""
            } w-72 h-32 rounded-4  justify-center  flex  items-center bg-white cursor-pointer`}
            style={{
              border: `1px solid ${["postDate-desc", "postDate-asc"].includes(sort) ? "#3264FF" : "#E8E8E8"}`,
            }}
            onClick={() => {
              onClick({ sort: sort === "postDate-desc" ? "postDate-asc" : "postDate-desc" });
            }}
          >
            時間
            <ArrowToBottomIcon
              fill={["postDate-desc", "postDate-asc"].includes(sort) ? "#3264FF" : "#333"}
              style={{
                transform: `rotate(${sort === "postDate-asc" ? "180deg" : "0"})`,
              }}
              size={32}
              strokeWidth={4}
            />
          </div>
          <div
            className={`${
              ["price-desc", "price-asc"].includes(sort) ? "text-[#3264FF]" : ""
            } w-72 h-32 rounded-4  justify-center flex  items-center bg-white cursor-pointer`}
            style={{
              border: `1px solid ${["price-desc", "price-asc"].includes(sort) ? "#3264FF" : "#E8E8E8"}`,
            }}
            onClick={() => {
              const isSort = ["postDate-desc", "postDate-asc"].includes(sort)
                ? "price-asc"
                : sort === "price-desc"
                ? "price-asc"
                : "price-desc";

              onClick({ sort: isSort });
            }}
          >
            價格
            <ArrowToBottomIcon
              fill={["price-desc", "price-asc"].includes(sort) ? "#3264FF" : "#333"}
              style={{
                transform: `rotate(${sort === "price-desc" ? "0" : "180deg"})`,
              }}
              size={32}
              strokeWidth={4}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(AmountMenu);
